import React from "react";
import { Route, Switch } from "react-router-dom";
import { DebtSearch } from "./DebtSearch";
import { DebtDetail } from "./DebtDetail";

interface Props {
  baseURL: string;
  userId: string;
  accessRole: any;
}
export const DebtManagement: React.FC<Props> = ({ baseURL, userId, accessRole }) => {
  return (
    <Switch>
      <Route path={`${baseURL}/acc/:id`}>
        <DebtDetail userId={userId} baseURL={baseURL} caption={""} value={0} loading={false} accessRole={accessRole} />
      </Route>
      <Route path={`${baseURL}`}>
        <DebtSearch baseURL={baseURL} caption={""} value={0} loading={false} accessRole={accessRole} />
      </Route>
    </Switch>
  );
};
